import { styled, css, Typography, TypographyProps } from '@mui/material'
import { getUnitValue } from '../../../utils/processStyles'
import { HeadingProps } from './Heading.types'

export const HeadingTypography = styled(Typography, {
  name: 'Heading'
})<HeadingProps & TypographyProps>(
  ({ size, lines }) => css`
    line-height: 1.3em;

    > b,
    > strong {
      font-weight: bold;
    }

    ${size &&
    css`
      font-size: ${getUnitValue(size)};
    `}

    ${!!lines &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${lines};
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      min-height: ${1.3 * lines}em;
    `};
  `
)

export default HeadingTypography
